// extracted by mini-css-extract-plugin
var _1 = "DnuEK";
var _2 = "Jf379 custom-attribute-color";
var _3 = "V8ypw";
var _4 = "S0jlF";
var _5 = "tiW_r";
var _6 = "yL0iD custom-attribute-color";
export { _1 as "base", _2 as "edit", _3 as "icon", _4 as "input", _5 as "inputContainer", _6 as "option" }
